import React, {useEffect} from "react";
import {Modal, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import {useFormik} from "formik";
import * as Yup from "yup";
import {formatWithMask, useMaskedInputProps} from "react-native-mask-input";
import {getFieldError} from "../utils";
import Div from "../lib/Div";
import P from "../lib/P";
import FontAwesome5 from "@expo/vector-icons/FontAwesome5";
import {SavedCardType} from "../types";
import {TextInput} from "react-native-paper";
import Btn from "../components/Btn";

type Props = { card?: SavedCardType, onClose: () => void, onConfirm: (cardUid: string, expiry: string) => void };

const expiryMask = [/\d/, /\d/, '/', /\d/, /\d/];

const SavedCardsModal = (props: Props) => {
  const {card} = props;
  const formik = useFormik({
    initialValues: {expiry: ''}, validationSchema: Yup.object({expiry: Yup.string().required().min(5)}),
    onSubmit: () => {
      if (!card) return;
      const {unmasked: expiry} = formatWithMask({text: formik.values.expiry, mask: expiryMask});
      props.onConfirm(card.cardUid, expiry);
    }
  });

  const expiryMaskedInputProps = useMaskedInputProps({
    value: formik.values.expiry, onChangeText: formik.handleChange('expiry'), mask: expiryMask
  });

  useEffect(() => {
    if (!card) formik.resetForm();
  }, [card]);

  return (
    <Modal animationType="fade" transparent visible={!!card?.cardMaskedNumber} statusBarTranslucent={false}
           hardwareAccelerated={false} onRequestClose={props.onClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div bg="#131314" w={343} rounded={16} overflow="hidden">
              <Div position="relative" bg="#252526" justifyContent="center">
                <P fontFamily="DavisSans-Medium" ta="center" lh={48}>Confirm Expiration Date</P>
                <FontAwesome5
                  name="times" size={28} color="white" style={[MainStyle.absolute, MainStyle.r_10]}
                  onPress={props.onClose}
                />
              </Div>

              <P fontFamily="DavisSans-Regular" mx={16} ta="center" mt={24} mb={30}>
                For your security, please confirm the expiration date ending in <P
                fontFamily="DavisSans-Medium">{card?.cardMaskedNumber.slice(-8)}.</P>
              </P>

              <TextInput
                keyboardType="numeric" onBlur={formik.handleBlur('expiry')} underlineColor="transparent"
                error={!!getFieldError('expiry', formik)} {...expiryMaskedInputProps} label="Expiration Date"
                placeholder="MM/YY" style={[MainStyle.b_r_4, MainStyle.m_b_30, MainStyle.m_x_16]}
              />

              <Btn mb={30} bg="#3369FF" rounded={4} onPress={() => formik.handleSubmit()} mx={16}>
                <P lh={56} ta="center" fontFamily="DavisSans-Medium" color="white">Confirm</P>
              </Btn>

              <Btn mb={24} onPress={() => props.onClose()}>
                <P ta="center" textDecorationLine="underline" fontFamily="DavisSans-Regular" color="white" lh={24}>
                  Back
                </P>
              </Btn>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default React.memo(SavedCardsModal);
